import React from "react"
import { LoaderCircle } from "lucide-mui"

const FullPageLoading = () => {
  // render spinner from MUI in the center of the screen

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-90 z-50"
      data-testid="panel-fullpage-loading"
    >
      <div className="animate-spin text-5xl text-gray-400" data-testid="panel-fullpage-loading-spinner">
        <LoaderCircle fontSize="inherit" className="block" />
      </div>
    </div>
  )
}

export default FullPageLoading
